import * as React from 'react'
import { styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'
import { updateUserLanguage } from '@/entities/user'
import { $userLanguage } from '@/entities/user'
import { useUnit } from 'effector-react'
import WebApp from '@twa-dev/sdk'

const CustomSwitch = styled((props: SwitchProps) => (
  <Switch
    focusVisibleClassName=".Mui-focusVisible"
    disableRipple
    {...props}
  />
))(() => ({
  width: 45,
  boxSizing: 'border-box',
  height: 32,
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  '& .MuiSwitch-switchBase': {
    display: 'flex',
    top: 2,
    width: 28,
    height: 28,
    backgroundColor: 'rgba(176, 177, 184, 0.12)',
    transform: 'translateX(2px)',
    ':hover': {
      backgroundColor: 'rgba(176, 177, 184, 0.12)',
    },

    '&.Mui-checked': {
      transform: 'translateX(15px)',
      backgroundColor: 'rgba(176, 177, 184, 0.12)',
      ':hover': {
        backgroundColor: 'rgba(176, 177, 184, 0.12)',
      },
      '& + .MuiSwitch-track': {
        backgroundColor: 'transparent',
        opacity: 1,
      },
    },
  },
  '& .MuiSwitch-thumb': {},
  '& .MuiSwitch-track': {
    borderRadius: 24,
    border: '1px solid rgba(176, 177, 184, 0.12)',
    backgroundColor: 'transparent',
    opacity: 1,
  },
}))

export const LanguageSwitch = () => {
  const userLang = useUnit($userLanguage)
  const [language, setLanguage] = React.useState<string>(userLang)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newLanguage: string = event.target.checked ? 'en' : 'ru'
    setLanguage(newLanguage)
    updateUserLanguage(newLanguage)
    WebApp.HapticFeedback.impactOccurred('soft')
  }

  return (
    <CustomSwitch
      checked={language === 'en'}
      onChange={handleChange}
      icon={
        <span
          style={{
            fontFamily: 'Inter',
            fontSize: '13px',
            fontWeight: 450,
            marginRight: '0px',
            marginBottom: '2px',
            color: 'rgba(117, 119, 120, 1)',
          }}
        >
          ru
        </span>
      }
      checkedIcon={
        <span
          style={{
            fontFamily: 'Inter',
            fontSize: '13px',
            fontWeight: 450,
            marginLeft: '2px',
            marginBottom: '2px',
            color: language === 'en' ? 'rgba(117, 119, 120, 1)' : 'rgba(176, 177, 184, 0.5)', // Цвет текста для 'en'
          }}
        >
          en
        </span>
      }
    />
  )
}
